import { Box, IconButton, Popover, Stack, Typography, useTheme } from "@compass/core";
import FingerprintIcon from "@mui/icons-material/Fingerprint";

import { DataModelEnum, DataModelInfo } from "generated/openApi";
import { useDateTime } from "hooks";
import { ReactNode, useEffect, useState } from "react";
import ApiService from "services/apiService";

export const DataModelInformation = (props: { dataModelType: DataModelEnum; dataModelId: number }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [dataModelInfo, setDataModelInfo] = useState<DataModelInfo>();
  const formatDateTime = useDateTime();

  useEffect(() => {
    if (Boolean(anchorEl)) {
      setDataModelInfo(undefined);
      ApiService.common.getDataModelInfo(props.dataModelType, props.dataModelId).then((response) => {
        setDataModelInfo(response);
      });
    }
  }, [anchorEl]);

  const renderPopoverContent = () => {
    return (
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Box p={3}>
          <Stack>
            {renderInfoLine("ID (System):", dataModelInfo?.id)}
            {renderInfoLine("Created by:", dataModelInfo?.createdBy)}
            {renderInfoLine("Created date:", formatDateTime(dataModelInfo?.createdDate))}
            {renderInfoLine("Modified by:", dataModelInfo?.modifiedBy)}
            {renderInfoLine("Modified date:", formatDateTime(dataModelInfo?.modifiedDate))}
            {renderInfoLine("File ID:", dataModelInfo?.fileId)}
          </Stack>
        </Box>
      </Popover>
    );
  };

  const renderInfoLine = (label: string, value: ReactNode | undefined) => {
    return (
      <Stack direction="row" spacing="sm" alignItems="center">
        <Typography sx={{ whiteSpace: "nowrap" }} variant="subtitle2" fontWeight={theme.typography.fontWeightRegular}>
          {label}
        </Typography>
        <Typography sx={{ whiteSpace: "nowrap" }} variant="subtitle2">
          {value}
        </Typography>
      </Stack>
    );
  };

  return (
    <>
      <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
        <FingerprintIcon />
      </IconButton>
      {renderPopoverContent()}
    </>
  );
};
